import { Facesheet } from '../types';

export const getFacesheetPillText = (facesheet: Facesheet): string => {
  const types: string[] = [];
  if (
    facesheet.templateTypes?.some(
      (templateType) => templateType.toUpperCase() === 'FULL',
    )
  ) {
    types.push('FULL');
  }
  if (
    facesheet.templateTypes?.some(
      (templateType) => templateType.toUpperCase() === 'HIE',
    )
  ) {
    types.push('HIE');
  }

  return types.join(', ');
};
